<div id="safety-app-risk-intelligence" ng-controller="RiskIntelligenceCtrl"></div>